async function parseResponse(response, errorMessage) {
  if (!response.ok) {
    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (!text) {
    return null;
  }

  return JSON.parse(text);
}

async function getWarehouseApplications() {
  const response = await fetch("/api/GetWarehouseApplications");

  return parseResponse(
    response,
    "Unable to load warehouse applications."
  );
}

async function createWarehouseApplication(payload) {
  const response = await fetch("/api/CreateWarehouseApplication", {
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  return parseResponse(
    response,
    "Unable to create warehouse application."
  );
}

async function updateWarehouseApplication(applicationId, payload) {
  const response = await fetch(
    `/api/UpdateWarehouseApplication/${encodeURIComponent(
      applicationId
    )}`,
    {
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    }
  );

  return parseResponse(
    response,
    "Unable to update warehouse application."
  );
}

async function deleteWarehouseApplication(applicationId) {
  const response = await fetch(
    `/api/DeleteWarehouseApplication/${encodeURIComponent(
      applicationId
    )}`,
    {
      method: "POST",
    }
  );

  return parseResponse(
    response,
    "Unable to delete warehouse application."
  );
}

export {
  createWarehouseApplication,
  deleteWarehouseApplication,
  getWarehouseApplications,
  updateWarehouseApplication,
};
